import { render, staticRenderFns } from "./SubAccount.vue?vue&type=template&id=74dcf84a&scoped=true&"
import script from "./SubAccount.vue?vue&type=script&lang=ts&"
export * from "./SubAccount.vue?vue&type=script&lang=ts&"
import style0 from "./SubAccount.vue?vue&type=style&index=0&id=74dcf84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dcf84a",
  null
  
)

export default component.exports